<template>
  <BaseTypeIndexShell base-type="offers" title="Angebotsübersicht">
    <ContractContingent objectType="offers" :activeObjectCount="activeMarketingObjects" :website-urls="clientWebsiteUrls" />
    <ObjectsTable
      :objects="objects"
      base-type="offers"
      :show-dates="true"
      :enable-sortable="true"
      :show-stats-action="true"
      :has-client-website="hasClientWebsite"
    />
  </BaseTypeIndexShell>
</template>

<script>
import ObjectsTable from "@/components/objects/ObjectsTable.vue";
import {useObjectStore} from "@/stores/object";
import ContractContingent from "@/components/objects/ContractContingent.vue";
import BaseTypeIndexShell from "@/components/base_type/BaseTypeIndexShell.vue";
import {useUserStore} from "@/stores/user";
import {useWebsitesStore} from "@/stores/websites";

export default {
  components: {
    BaseTypeIndexShell,
    ContractContingent,
    ObjectsTable,
  },
  data() {
    return {
      objects: [],
    }
  },
  setup() {
    return {
      objectStore: useObjectStore(),
      userStore: useUserStore(),
      websiteStore: useWebsitesStore(),
    }
  },
  created() {
    this.objectStore.apiIndex(this.$route.meta.base_type).then(({data}) => {
      this.objects = Array.isArray(data) ? data : data?.objects || []
    })
    this.websiteStore.index(this.currentKdnr).catch((error) => {
      console.error('websiteStore.index failed', error)
    })
  },
  computed: {
    currentKdnr() {
      return this.userStore.user?.organisation?.kdnr || this.$route.query.kdnr || null
    },
    hasClientWebsite() {
      return String(this.websiteStore.loadedKdnr || '') === String(this.currentKdnr || '')
        && this.websiteStore.items.length > 0
    },
    clientWebsiteUrls() {
      return this.hasClientWebsite ? this.websiteStore.items.map((website) => website.url || '') : []
    },
    activeMarketingObjects() {
      return this.objects.filter(o => o.setting_enable_in_manet_stadt_abl === true).length
    },
  },
}
</script>
